<div class="container">
  <div *ngIf="isCBM(assessment.productId)" class="result-container">
    <div class="swatch round" [ngStyle]="{'background-color':getCBMColor(assessment.cbmBenchmarkCategory)}"></div>
    <div class="text">
      <div>{{generateCBMCategory(assessment.cbmBenchmarkCategory)}}</div>
      <div>Correct Per Minute: {{assessment.correctPerMinute}}</div>
      <div>Accuracy: {{toPercent(assessment.accuracy)}}</div>
    </div>
  </div>
  <div *ngIf="isFastBridge(assessment.logo)" class="result-container">
    <div class="swatch"> <img class="swatch-svg" alt="" [src]="getFastBridgeBenchmarkSwatch(assessment.benchmarkCategory)"/></div>
    <div class="text">
      <div>{{assessment.benchmarkCategory}}</div>
      <div *ngIf="assessment.correctPerMinute">Correct Per Minute: {{assessment.correctPerMinute}}</div>
      <div *ngIf="assessment.accuracy">Accuracy: {{toPercent(assessment.accuracy)}}</div>
      <div>Percentile Rank: {{assessment.percentileRank}}</div>
      <div *ngIf="assessment.currentSGP">Current SGP: {{getSGPText(assessment.currentSGP)}}</div>
      <button
        *ngIf="isFastBridgeLicensed"
        class="progress-monitoring-report"
        (click)="launchFastBridgeProgressMonitoringReport()"
        (keyup.enter)="launchFastBridgeProgressMonitoringReport()"
      >
        Progress Monitoring Report
        <span class="glyph-externallink" tabindex="-1" role="img"></span>
    </button>
    </div>
  </div>
  <div *ngIf="!isCBM(assessment.productId) && !isFastBridge(assessment.logo)" class="result-container">
    <div class="swatch" [ngStyle]="{'background-color': getStudentCategoryColor(assessment)}"></div>
    <div class="text">
      <div>{{getStudentCategoryTitle(assessment)}}</div>
      <div>Scaled Score: {{assessment.scaledScore}}</div>
      <div>Percentile Rank: {{assessment.percentileRank}}</div>
      <div>Current SGP: {{getSGPText(assessment.currentSGP)}} {{getGrowthCategory(assessment.currentSGP)}}</div>
    </div>
  </div>
</div>
